
var ServiceModel = require('../../app/models/service');
var CategoryModel = require('../../app/models/category');
var RitualModel = require('../../app/models/ritual');
var EmployeeModel = require('../../app/models/employee');

var AppointmentManager = function() {
  this.init();
  _.extend(this, Backbone.Events);
};


AppointmentManager.prototype = {
  init: function() {
    this.guestsInfo = [];
  },

  setGuestsInfo: function(guests) {
    this.guestsInfo = guests;
  }

};


module.exports = AppointmentManager;
